module.exports = {"compact":{"xl":12,"lg":15,"md":15,"sm":12,"xs":12},"large":{"xl":false,"lg":15,"md":15,"sm":12,"xs":12}}


//////////////////
// WEBPACK FOOTER
// ./scripts/config/logosPerGroup.json
// module id = 96
// module chunks = 0